module.exports = require("@bechtel/client-assets/dist/images/pattern-red.svg");